import { useEffect, useState } from 'react';
import type { ReactElement } from 'react';

type LazyRoute = { path: string; component: ReactElement };

export const useLazyRoutes = () => {
  const [lazyRoutes, setLazyRoutes] = useState<LazyRoute[]>([]);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    (async () => {
      try {
        const { lazyRoutes: routes } = await import('./lazyRoutes');
        setLazyRoutes(routes);
      } catch (err) {
        setError(err as Error);
      }
    })();
  }, []);

  if (error) throw error;

  return lazyRoutes;
};
